


























import { defineComponent } from '@vue/composition-api';
import { t } from '../../helpers/translation.helper';
import useBreakpoints from '../../composables/breakpoints.composable';
import { TooltipPlacement } from '../../enums/tooltip-placement';
import CommentExcerpt from './CommentExcerpt.vue';

export default defineComponent({
  components: {
    CommentExcerpt,
  },
  props: {
    targetText: {
      type: String,
      required: true,
    },
    isResolved: {
      type: Boolean,
    },
    isGhost: {
      type: Boolean,
    },
  },
  setup() {
    const { isSmallScreenAndDown } = useBreakpoints();

    return {
      TooltipPlacement,
      isSmallScreenAndDown,
      t,
    };
  },
});
